var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './SonarCard.scss';
import classNames from 'classnames';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { Card, Col, Row } from 'antd';
import React, { forwardRef } from 'react';
export const SonarCard = forwardRef((_a, ref) => {
    var { children, className, extra, icon, loading, noSpacing, noSpacingX, title, titleClassName = 'h1', useSpinnerLoading } = _a, rest = __rest(_a, ["children", "className", "extra", "icon", "loading", "noSpacing", "noSpacingX", "title", "titleClassName", "useSpinnerLoading"]);
    let cardTitle = typeof title === 'string' ?
        React.createElement("div", { className: classNames(titleClassName, { 'with-icon': Boolean(icon) }) }, title) :
        title;
    if (icon) {
        cardTitle = React.createElement(React.Fragment, null,
            icon,
            cardTitle);
    }
    const useCustomTitle = Boolean(cardTitle) && Boolean(extra);
    const displayTitle = useCustomTitle ?
        React.createElement(Row, { align: 'middle', justify: 'space-between' },
            React.createElement(Col, null, cardTitle),
            React.createElement(Col, null, extra)) :
        cardTitle;
    return (React.createElement(Card, Object.assign({ className: classNames('sonar-card', {
            'no-spacing': noSpacing,
            'no-spacing-x': noSpacingX
        }, className), extra: useCustomTitle ? undefined : extra, loading: useSpinnerLoading ? undefined : loading, ref: ref, title: displayTitle }, rest), useSpinnerLoading ?
        React.createElement(LoadingSpinner, { minDuration: 1000, opaque: true, spinning: loading }, children) : children));
});
